import { IRootProps } from "../interfaces";

export default function LayoutPlansAndAppsEcosystem({ children }: IRootProps) {
  return (
    <>
      {children}
    </>
  );
}
